export var ExchangeStep;
(function (ExchangeStep) {
    ExchangeStep[ExchangeStep["Passengers"] = 0] = "Passengers";
    ExchangeStep[ExchangeStep["Segments"] = 1] = "Segments";
    ExchangeStep[ExchangeStep["NewFlights"] = 2] = "NewFlights";
    ExchangeStep[ExchangeStep["Request"] = 3] = "Request";
    ExchangeStep[ExchangeStep["Payment"] = 4] = "Payment";
    ExchangeStep[ExchangeStep["Reasons"] = 5] = "Reasons";
})(ExchangeStep || (ExchangeStep = {}));
